import { GetterTypes } from '@/store-vuex/types';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Loader extends Vue {
    // Get loading state from store
    protected get isLoading(): boolean { return this.$store.getters[GetterTypes.dataLoading]; }
}
